<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Área do Cliente</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form @submit.prevent="login" autocomplete="off">
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col d-flex justify-content-center">
                <img :src="require('@/img/brand-drachei-big.svg')" alt="DrAchei">
              </div>
            </div>
            <div class="row">
              <div class="col d-flex justify-content-center">
                <a href="#" @click="fazerCadastro()" class="btn btn-lg btn-primary button-big">Fazer o cadastro</a>
              </div>
            </div>
          </div>
          
          <div class="form-logincliente">
            <div class="col">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="username">Usuário</label>
                  <input v-model="auth.username" required type="text" name="username" id="username" class="form-control">
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="password">Senha</label>
                  <input v-model="auth.password" required type="password" name="password" id="password" class="form-control">
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col">
                <input type="checkbox" v-model="persistCredentials"> <small>Mantenha-me conectado</small>
              </div>  
            </div>

            <div class="row">
              <div class="col-6 text-center">
               <a href="#" class="btn btn-light" @click.stop.prevent="$emit('changeTo', 'esqueciSenhaCliente')"><small>Esqueci minha senha</small></a>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col text-right mb-2">
                <div class="btn-login">
                  <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Cancelar</button>
                  <button type="submit" class="btn btn-primary">Entrar</button>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import eventBus from '@/event-bus'

export default {
  data () {
    return {
      persistCredentials: false,
      auth: {
        username: null,
        password: null
      }
    }
  },
  methods: {
    resetForm () {
      this.auth.username = null
      this.auth.password = null
    },

    login () {
      this.$store.dispatch('loginCliente', this.auth)
        .then((user) => {
          window.$('#drAcheiModal').modal('hide')
          this.$nextTick(() => eventBus.$emit('loginSuccess', user))
        })
    },

    fazerCadastro () {
      window.$('#drAcheiModal').modal('hide')
      if (window.localStorage.getItem('cartaoCompra')) {
        this.$router.push({name: 'Cadastrese-usuarioDrAchei'})
      } else {
        this.$router.push({name: 'Cadastrese-pergunta'})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LoginCliente.vue